export class LabcoreRequest{
    constructor(
        public OrderCount?: string,
        public PatientDocumentType?: string,
        public PatientDocumentNumber?: string,
        public ReportCode?: string
    ){}    
}


// WEBPACK FOOTER //
// /app/src/app/shared/models/labcore-request.model.ts